import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const takeWhileAsync = (source, predicate) => {
    const generator = async () => {
        const values = await source.toArray();
        const results = new Array();
        if (predicate.length === 1) {
            const sPredicate = predicate;
            for (const value of values) {
                if (await sPredicate(value) === true) {
                    results.push(value);
                }
                else {
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < values.length; i++) {
                const value = values[i];
                if (await predicate(value, i) === true) {
                    results.push(value);
                }
                else {
                    break;
                }
            }
        }
        return results;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
